<section class="w-full max-w-lg mx-auto flex flex-col gap-4 min-w-0 px-1">
  @if (proUpgradeRequired) {
    <div class="rounded-xl border border-amber-200 bg-amber-50 p-6 text-center space-y-3">
      <span class="material-symbols-outlined text-amber-600 text-4xl">workspace_premium</span>
      <p class="text-sm text-gray-800">
        Pour bénéficier de cette fonctionnalité, il faudra passer sur l'abonnement Pro.
      </p>
      <span class="inline-block rounded-full bg-amber-100 px-3 py-1 text-xs font-medium text-amber-800">À venir</span>
    </div>
  } @else {
    <div class="relative">
      <input
        type="text"
        placeholder="Tapez le nom de l'entreprise"
        class="w-full rounded-lg border border-gray-300 px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-secondary"
        [value]="query()"
        (input)="onQueryInput($any($event.target).value)"
      />
      <div class="absolute right-3 top-1/2 -translate-y-1/2">
        @if (searching()) {
          <span class="material-symbols-outlined animate-spin text-gray-400 text-[18px]">progress_activity</span>
        } @else {
          <lucide-icon [name]="Search" [size]="18"></lucide-icon>
        }
      </div>

      @if (showSuggestions()) {
        <div class="absolute z-40 mt-1 w-full rounded-xl bg-white border border-gray-200 shadow-xl max-h-72 overflow-y-auto">
          @for (suggestion of suggestions(); track suggestion.siret) {
            <button
              type="button"
              (click)="selectSuggestion(suggestion)"
              class="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0"
            >
              <div class="text-sm font-medium text-gray-900 truncate">{{ suggestion.companyName || 'Entreprise' }}</div>
              <div class="text-[11px] text-gray-500">
                SIREN {{ suggestion.siren || '—' }} · {{ suggestion.city || '—' }}
              </div>
            </button>
          } @empty {
            <div class="p-4 text-sm text-center text-gray-500">Aucune entreprise trouvée</div>
          }
        </div>
      }
    </div>

    <div>
      @if (loading()) {
        <p class="text-sm text-gray-500">
          Chargement des données de l'entreprise...
        </p>
      }

      @if (error()) {
        <p class="text-sm w-full text-center py-2 bg-red-200 border font-bold border-red-400 rounded-md text-red-400">
          {{ error() }}
        </p>
      }

      @if (company()) {
        <div class="rounded-lg border p-4 bg-gray-50 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
          <div class="space-y-2 min-w-0">
            <p class="font-semibold text-base sm:text-lg break-words">
              {{ company()?.nom_entreprise || company()?.denomination }}
            </p>

            <p class="text-sm text-gray-600">
              SIREN : {{ company()?.siren_formate }}
            </p>

            <p class="text-sm text-gray-600 break-words">
              Activité : {{ company()?.libelle_code_naf }}
            </p>

            <p class="text-sm text-gray-600">
              Créée le : {{ company()?.date_creation_formate }}
            </p>
          </div>

          <div class="w-full sm:w-auto shrink-0">
            <button
              (click)="addCompany()"
              [disabled]="companyAdded()"
              class="relative flex w-full sm:w-auto items-center justify-center h-11 min-w-[120px] rounded-md font-medium transition-all duration-300 ease-in-out overflow-hidden bg-secondary hover:bg-secondary-hover text-white
              disabled:cursor-default cursor-pointer"
              [class.bg-green-600]="companyAdded()"
            >
              <span
                class="flex items-center gap-2 transition-all duration-300"
                [class.opacity-0]="companyAdded()"
                [class.scale-90]="companyAdded()"
              >
                <lucide-icon [name]="Plus" [size]="18"></lucide-icon>
                Ajouter
              </span>

              <span
                class="absolute flex items-center justify-center transition-all duration-300"
                [class.opacity-100]="companyAdded()"
                [class.scale-100]="companyAdded()"
                [class.opacity-0]="!companyAdded()"
                [class.scale-50]="!companyAdded()"
              >
                <lucide-icon [name]="Check" [size]="22"></lucide-icon>
              </span>
            </button>
          </div>
        </div>
      }
    </div>
  }
</section>
